/**
 * Text Type Names
 * 
 * Simple constants for identifying text types on the canvas.
 * Character limits are now defined in AdSizeConfig.text.
 */

export const TEXT_TYPE_NAMES = {
    HEADLINE: 'Headline',
    SUBHEADLINE: 'SubHeadline',
} as const

export type TextTypeName = (typeof TEXT_TYPE_NAMES)[keyof typeof TEXT_TYPE_NAMES]
